module.exports = __webpack_public_path__ + "img/icon-clear-blue.e244ad62.svg";